import { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

import { MoroccoForm } from "../NewForm/MoroccoForm";
import SuccessfullMessage from "../NewForm/SuccessfullMessage";

import signBanner from "../../assets/images/signupSideBanner.png";
import googleButton from "../../assets/images/googleButton.png";
import appleButton from "../../assets/images/appleButton.png";
// import mobileFrame from "../../assets/images/mobileFrame.png";

import "react-toastify/dist/ReactToastify.css";
import "../NewForm/flags.css";

import "./GodoForm.css"; // Assuming you have a CSS file for styling
import LanguageTranslation from "../NewForm/LanguageTranslation";
import FormTypes from "../NewForm/FormTypes";
import Loader from "./Loader";

const GodoForm = () => {
  const logo = `${process.env.PUBLIC_URL}/tradepro_logo.png`;
  const [submittedData, setSubmittedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [, setFormType] = useState("Corporate");
  const [button, setButton] = useState("");

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const device = searchParams.get("device");

    if (device) {
      setButton(device);
    }

  }, [])

  return (
    <div
      className="d-sm-flex IndividuallayoutContainer formDimission" // Full height container
    >
      <Col
        md={6}
        className={`position-relative p-0 ${submittedData ? "d-none" : "d-block"
          } d-sm-none`}
      >
        <img
          // src={mobileFrame}
          // alt="mobileFrame"
          style={{
            width: "100%",
            height: "auto",
            objectFit: "cover",
          }}
        />
        <div className="mobileLinkWrapper position-absolute d-flex gap-3 align-items-center">
          {button === 'IOS' ? <a href="https://apps.apple.com/ae/app/godo-app-start-trading-now/id6742449171">
            <img src={appleButton} alt="appleButton" />
          </a> : button === 'ANDROID' ?
            <a href="https://play.google.com/store/apps/details?id=com.godocp.godo">
              <img src={googleButton} alt="googleButton" />
            </a> :
            <>
              <a href="https://apps.apple.com/ae/app/godo-app-start-trading-now/id6742449171">
                <img src={appleButton} alt="appleButton" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.godocp.godo">
                <img src={googleButton} alt="googleButton" />
              </a>
            </>
          }
        </div>
      </Col>

      {/* LEFT SCROLLABLE FORM COLUMN */}
      <Col
        md={6}
        className="scrollableFormSection" // scrollable left
      >
        {!submittedData && !loading ? (
          <>
            <div className="d-flex justify-content-center justify-content-lg-between">
              <a
                href="https://www.godocm.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="d-none d-lg-inline-flex flex-column align-items-center mt-2 mb-lg-4 mb-lg-0 text-decoration-none flex-shrink-0"
              >
                <img
                  src={logo}
                  alt="I Trade Pro"
                  style={{ width: "280px", height: "90px", objectFit: "contain" }}
                />
              </a>
              <div className="d-flex gap-4 mt-3 mt-lg-0 justify-content-center justify-content-sm-end align-items-center">
                <a
                  href="https://www.godocm.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-lg-none d-inline-flex flex-column align-items-center flex-shrink-0 text-decoration-none"
                >
                  <img
                    src={logo}
                    alt="I Trade Pro"
                    className="mt-2"
                    style={{ width: "280px", height: "90px", objectFit: "contain" }}
                  />
                </a>
                <LanguageTranslation />
                <FormTypes className="logoCss" setFormType={setFormType} />
              </div>
            </div>

            <Row style={{ alignItems: "center", marginBottom: "8px" }}>
              <Col
                md={12}
                className={`${i18n.language === "ar" || i18n.language === "ir"
                  ? "text-end d-flex flex-column justify-content-end align-items-end"
                  : ""
                  } text-lg-start mt-4 mt-lg-2`}
              >
                <h3 className="fw-bold">{t("CreateYourAccount")}</h3>
                <p className="mb-0">{t("AchievingYourFinancialGoals")}</p>
              </Col>
            </Row>

            <MoroccoForm
              setSubmittedData={setSubmittedData}
              setLoading={setLoading}
            />
          </>
        ) : loading ? (
          <div
            className="d-flex justify-content-center align-items-center py-5 w-100"
            style={{ minHeight: 280, maxHeight: "90vh" }}
            aria-live="polite"
            aria-busy="true"
            role="status"
          >
            <Loader />
          </div>
        ) : (
          <SuccessfullMessage submittedData={submittedData} />
        )}
      </Col>

      {/* RIGHT STICKY IMAGE COLUMN */}
      <Col
        md={6}
        className="signupSideBannerColumn position-relative p-0 d-none d-sm-block"
      >
        <div className="signupSideBannerSticky">
          <img
            src={signBanner}
            alt="iTRADEPRO MARKETS, trade like a pro"
            className="signupSideBannerImg"
          />
        </div>
      </Col>

      <ToastContainer />
    </div>
  );
};

export default GodoForm;
